import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import Selectors from "../Selectors";
import ActionCreator from "../ActionCreator";
import * as Widget from "./Widget2";
import StoreListItem from "./StoreListItem";

class StoreCategorySection extends Component {
  render() {
    let { data, css, navActions } = this.props;

    return (
      <Wrapper css={css}>
        {data && (
          <>
            <Widget.Col align="center" className="section-title">
              <Widget.Row align="center" justify="center" className="text">
                <img src={`/images/pages/store/${data.img}.png`} />
                <span>{data.display}</span>
              </Widget.Row>
              <div className="line" />
            </Widget.Col>
            <div className="content">
              {this._renderStores(data).map((item, i) => (
                <StoreListItem
                  key={"store-list-item" + i}
                  item={item}
                  css="margin-bottom: 50px;"
                  onClick={() => navActions.push(`/store/?id=${item.id}`)}
                />
              ))}
              <StoreListItem
                css={`
                  height: 0px;
                  & > .left {
                    margin-right: 0px;
                    border: 0px;
                    height: 0px;
                    width: 0px;
                  }
                `}
              />
              <StoreListItem
                css={`
                  height: 0px;
                  & > .left {
                    margin-right: 0px;
                    border: 0px;
                    height: 0px;
                    width: 0px;
                  }
                `}
              />
            </div>
          </>
        )}
      </Wrapper>
    );
  }

  _renderStores = data => {
    let { results } = this.props.storeList;
    let storeArray = [];
    try {
      storeArray = results.filter(d => {
        if (d.label) {
          let label = JSON.parse(d.label);

          for (let i = 0; i < label.length; i++) {
            if (label[i] === data.display) {
              return d;
            }
          }
        }
      });
    } catch (err) {
      console.warn(err);
    }

    return storeArray;
  };
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  & > .section-title {
    margin-bottom: 60px;
    & > .text {
      margin-bottom: 12px;
      min-width: 260px;
      & > img {
        margin-right: 10px;
        width: 30px;
        height: 30px;
      }

      & > span {
        letter-spacing: 3.9px;
        font-size: 26px;
      }
    }

    & > .line {
      width: 90px;
      height: 5px;
      background-color: #bd9f84;
    }
  }

  & > .content {
    width: 100%;
    padding: 20px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 500px) {
    & > .content {
      justify-content: center;
    }
  }

  ${props => props.css}
`;

export default connect(
  (state, ownProps) => ({
    storeList: Selectors.getStoreList(state)
  }),
  ActionCreator
)(StoreCategorySection);
